export const SINGLEPAGECATEGORIES = ["SLEEP", "STRESS RESPONSE", "HORMONES"];
